declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData } from '../../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-grade',
    templateUrl: './autogengrade.component.html',
    styleUrls: ['./autogengrade.component.scss']
})

export class AutoGenGradeComponent implements OnInit {

    @Input() public field: FieldData;
    ngOnInit(): void {
       
    }
}
